import SortPopup, { SortOption } from "../../../components/sort_popup/sort_popup";

export type NotificationsSortOption = "newest" | "oldest";

export const DEFAULT_NOTIFICATIONS_SORT_OPTION: NotificationsSortOption = "newest";

const OPTIONS: SortOption<NotificationsSortOption>[] = [
  { value: "newest", label: "New to old" },
  { value: "oldest", label: "Old to new" },
];

export function notificationsSortOptionLabel(option: NotificationsSortOption): string {
  return OPTIONS.find((o) => o.value === option)!.label;
}

// Notifications' list endpoint only supports a single sortOrder param
// (no sortBy, always ordered by createdAt) - this maps the single
// date-based choice straight to it.
export function notificationsSortOptionToSortOrder(option: NotificationsSortOption): "ASC" | "DESC" {
  return option === "newest" ? "DESC" : "ASC";
}

export default function SortNotificationsPopup({
  open,
  onClose,
  sortOption,
  setSortOption,
}: {
  open: boolean;
  onClose: () => void;
  sortOption: NotificationsSortOption;
  setSortOption: (option: NotificationsSortOption) => void;
}) {
  return (
    <SortPopup
      open={open}
      onClose={onClose}
      title="Sort Notifications"
      options={OPTIONS}
      value={sortOption}
      onApply={setSortOption}
    />
  );
}
